import { Sparkles } from 'lucide-react';

/**
 * PrefillBanner — shared "Pre-filled from your visa recommendation" surface.
 * Used by ConsultationForm, BookCounsellingPage, and FreeProfileEvaluationPage.
 *
 * Variants:
 *   - 'light'   (default) — amber/cream background for white-bg forms
 *   - 'dark'    — gold-on-slate for dark-bg forms
 *   - 'compact' — single-line, no description (small forms)
 */
const PrefillBanner = ({ variant = 'light', onDismiss, message, testid = 'form-prefill-banner' }) => {
  const isDark = variant === 'dark';
  const palette = isDark
    ? 'bg-[#C5A028]/10 border border-[#C5A028]/30 text-slate-200'
    : 'bg-amber-50 border border-amber-200 text-amber-900';
  const iconColor = isDark ? 'text-[#C5A028]' : 'text-amber-700';
  const subColor  = isDark ? 'text-slate-400' : 'text-amber-800/80';
  const dismissColor = isDark
    ? 'text-slate-400 hover:text-white'
    : 'text-amber-700 hover:text-amber-900';

  return (
    <div
      className={`flex items-start gap-2 px-3 py-2 rounded-lg text-xs ${palette}`}
      data-testid={testid}
    >
      <Sparkles className={`w-4 h-4 mt-0.5 shrink-0 ${iconColor}`} aria-hidden="true" />
      <div className="flex-1">
        <strong className="font-semibold">Pre-filled from your visa recommendation.</strong>{' '}
        {message && <span className={subColor}>{message}</span>}
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className={`text-[10px] font-bold tracking-wider uppercase underline ${dismissColor}`}
          data-testid={`${testid}-dismiss`}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default PrefillBanner;
